function hasActiveOrders(state) {
  return state.activeOrders && state.activeOrders.length > 0;
}

export default { hasActiveOrders };
